export enum scoutsTypes {
  FETCH_SCOUTS_REQUEST = "FETCH_SCOUTS_REQUEST",
  FETCH_SCOUTS_SUCCESS = "FETCH_SCOUTS_SUCCESS",
  FETCH_SCOUTS_FAILURE = "FETCH_SCOUTS_FAILURE",
}